import { AdminAppState, EventEntry } from '../../state';
import { getEvent } from './get-event';

export const getEventPosterImages = (eventKey: string) => (
  store: AdminAppState,
): EventEntry['event']['posterImages'] =>
  getEvent(eventKey)(store).posterImages;
